import Grid from "@mui/material/Grid";
import React from "react";
import { useForm } from "../../../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import HighlightBox from "../../../../Box/HighlightBox/HighlightBox";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import MuiListNativeStyled from "../../../../List/MuiListNativeStyled";
import lawsuitConsequencesStyle from "./lawsuitConsequencesStyle";

type LawsuitConsequencesProps = {
  product: AbstractCase;
};

const LawsuitConsequences = ({ product }: LawsuitConsequencesProps) => {
  const { values } = useForm();

  if (values.finalProcessFeedbackClient !== "lawsuit") {
    return null;
  }

  return (
    <Grid sx={{ marginBottom: 2 }} size={12}>
      <HighlightBox textColor={"defaultText"} textAlign={"center"}>
        {(product.caseInsurance.iIWPI || product.legalExpenseInsurance) && product.caseInsurance.judicialCoverageGranted !== true && (
          <>
            <Typography>
              <strong>Wir stellen umgehend eine Deckungsanfrage</strong>
            </Typography>
            <Typography>
              Sofern Sie den Klageweg bestreiten möchten, werden wir unmittelbar eine Deckungsanfrage bei Ihrer Rechtsschutzversicherung für das gerichtliche
              Verfahren stellen und uns auch bei Rückfragen seitens der Versicherung um alles Weitere kümmern.
            </Typography>
            <br />
            <Typography>
              <strong>Sollte die Rechtsschutzversicherung keine Deckungszusage erteilen,</strong> müssen Sie sich keine Sorgen machen. Wir beenden das Verfahren
              dann umgehend und es kommen keinerlei Kosten auf Sie zu.
            </Typography>
            <br />
            <Typography>
              <strong>Sollte die Rechtsschutzversicherung die Deckungszusage erteilen,</strong> starten wir unmittelbar in das Klageverfahren.
            </Typography>
            <br />
          </>
        )}
        <Typography>
          Bitte beachten Sie, dass ein Gerichtsverfahren verschiedene Aspekte mit sich bringen kann, die Sie für Ihre Entscheidung berücksichtigen sollten:
        </Typography>
        <br />
        {product.paymentType === "private" && product.caseCategory === "enforceClaim" && (
          <MuiListNativeStyled
            sx={lawsuitConsequencesStyle.listStyle}
            listItems={[
              <>
                <strong>Es besteht ein erhebliches Kostenrisiko für Sie</strong>
                <MuiListNativeStyled
                  sx={lawsuitConsequencesStyle.listStyle}
                  listItems={[
                    <>
                      Bestimmte <strong>Kosten</strong> müssen Sie bereits zu Beginn des Verfahrens selbst <strong>vorstrecken</strong> – unabhängigdavon, wie
                      das Verfahren später ausgeht.
                      <MuiListNativeStyled
                        sx={lawsuitConsequencesStyle.listStyle}
                        listItems={[
                          <>
                            Dazu gehört zunächst der <strong>Gerichtskostenvorschuss</strong>, der erforderlich ist, damit das Gericht Ihre Klage überhaupt
                            bearbeitet. Die Höhe dieses Vorschusses richtet sich nach dem sogenannten Streitwert, also dem wirtschaftlichen Interesse der Klage.{" "}
                            <strong>Ohne fristgerechte Zahlung erfolgt keine Bearbeitung durch das Gericht.</strong>
                          </>,
                          <>
                            Es entstehen <strong>eigene Anwaltskosten</strong> für unsere Tätigkeit - sowohl für die Einreichung der Klage als auch für die
                            gerichtliche Vertretung und etwaige außergerichtliche Schritte. Diese Gebühren sind gesetzlich geregelt und ebenfalls vom Streitwert
                            abhängig.
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                Sollten im Laufe des Verfahrens <strong>Sachverständigengutachten</strong> zu Ihren Angaben notwendig werden – etwa zur Klärung der Schadenshöhe
                –, müssen auch diese Kosten zunächst von Ihnen verauslagt werden. Je nach Umfang und Fachgebiet können hier{" "}
                <strong>mehrere hundert bis mehrere tausend Euro</strong> anfallen.
              </>,
              <>
                <strong>Die endgültige Kostenverteilung richtet sich nach dem Ausgang des Verfahrens</strong>
                <MuiListNativeStyled
                  sx={lawsuitConsequencesStyle.listStyle}
                  listItems={[
                    <>
                      Wenn Sie den Rechtsstreit <strong>vollständig gewinnen</strong>, ist die Gegenseite in der Regel verpflichtet, Ihnen sämtliche Kosten zu
                      erstatten – einschließlich Ihrer Anwalts- und Gerichtskosten sowie etwaiger Gutachterkosten.
                    </>,
                    <>
                      Bei einem <strong>teilweisen Obsiegen</strong> kann das Gericht eine anteilige Kostenteilung anordnen. In diesem Fall erhalten Sie einen
                      Teil Ihrer Auslagen zurück, müssen aber auch einen Teil der Kosten – unter Umständen einschließlich der gegnerischen Anwaltskosten –
                      selbst tragen.
                    </>,
                    <>
                      Sollten Sie den Prozess <strong>vollständig verlieren</strong>, tragen Sie sämtliche eigenen Kosten und zusätzlich die Anwaltskosten der
                      Gegenseite. Auch die Gerichtskosten und Sachverständigenkosten müssen dann in voller Höhe von Ihnen getragen werden.
                    </>,
                  ]}
                />
              </>,
            ]}
          />
        )}
        {product.paymentType === "private" && product.caseCategory === "defendClaim" && (
          <MuiListNativeStyled
            sx={lawsuitConsequencesStyle.listStyle}
            listItems={[
              <>
                <strong>Es besteht ein erhebliches Kostenrisiko für Sie</strong>
                <MuiListNativeStyled
                  sx={lawsuitConsequencesStyle.listStyle}
                  listItems={[
                    <>
                      Es entstehen <strong>eigene Anwaltskosten</strong> für unsere Tätigkeit. Diese Gebühren sind gesetzlich geregelt und vom Streitwert
                      abhängig.
                    </>,
                    <>
                      Sollten im Laufe des Verfahrens <strong>Sachverständigengutachten</strong> zu Ihren Angaben notwendig werden – etwa zur Klärung der
                      Schadenshöhe –, müssen auch diese Kosten zunächst von Ihnen verauslagt werden. Je nach Umfang und Fachgebiet können hier{" "}
                      <strong>mehrere hundert bis mehrere tausend Euro</strong> anfallen.
                    </>,
                    <>
                      <strong>Die endgültige Kostenverteilung richtet sich nach dem Ausgang des Verfahrens</strong>
                      <MuiListNativeStyled
                        sx={lawsuitConsequencesStyle.listStyle}
                        listItems={[
                          <>
                            Wenn Sie den Rechtsstreit <strong>vollständig gewinnen</strong>, ist die Gegenseite in der Regel verpflichtet, Ihnen sämtliche
                            Kosten zu erstatten – einschließlich Ihrer Anwalts- und Gerichtskosten sowie etwaiger Gutachterkosten.
                          </>,
                          <>
                            Bei einem <strong>teilweisen Obsiegen</strong> kann das Gericht eine anteilige Kostenteilung anordnen. In diesem Fall erhalten Sie
                            einen Teil Ihrer Auslagen zurück, müssen aber auch einen Teil der Kosten – unter Umständen einschließlich der gegnerischen
                            Anwaltskosten – selbst tragen.
                          </>,
                          <>
                            Sollten Sie den Prozess <strong>vollständig verlieren</strong>, tragen Sie sämtliche eigenen Kosten und zusätzlich die Anwaltskosten
                            der Gegenseite. Auch die Gerichtskosten und Sachverständigenkosten müssen dann in voller Höhe von Ihnen getragen werden.
                          </>,
                        ]}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />
        )}
        {(product.caseInsurance.iIWPI || product.legalExpenseInsurance) && (
          <>
            <MuiListNativeStyled
              sx={lawsuitConsequencesStyle.listStyle}
              listItems={[
                <>
                  Es können sich je nach bisheriger Beanspruchung Ihrer Versicherung gegebenenfalls die{" "}
                  <strong>Beitragszahlungen Ihrer Rechtsschutzversicherung erhöhen.</strong>
                </>,
                ...(product.productCategory === "administrativeLaw"
                  ? [
                      <>
                        Da die Gegenseite (Ihr Dienstherr) sich in der Regel selbst vertritt, fallen meist <strong>keine gegnerischen Anwaltskosten</strong> an.
                        Sollten solche ausnahmsweise doch entstehen (z. B. bei externer anwaltlicher Vertretung der Behörde), müssten Sie diese im Falle des
                        Unterliegens übernehmen.
                      </>,
                    ]
                  : [
                      <>
                        Wenn die Gegenseite sich schon vor dem gerichtlichen Verfahren von einem Rechtsanwalt vertreten ließ, müssen Sie{" "}
                        <strong>dessen außergerichtliche Rechtsanwaltskosten übernehmen, falls Sie den Prozess verlieren.</strong> Dies ist nicht von Ihrer
                        Rechtsschutzversicherung gedeckt.
                      </>,
                    ]),
              ]}
            />

            {product.extrajudicialRecommendation !== "lawsuit" && (
              <MuiListNativeStyled
                sx={lawsuitConsequencesStyle.listStyle}
                listItems={[
                  <>
                    Die entstehenden Kosten des Gerichtsverfahrens werden zwar größtenteils von Ihrer Rechtsschutzversicherung getragen,{" "}
                    <strong>Sie müssen jedoch im Falle eines Unterliegens den Selbstbehalt selber zahlen</strong>.
                  </>,
                ]}
              />
            )}
          </>
        )}

        <MuiListNativeStyled
          sx={lawsuitConsequencesStyle.listStyle}
          listItems={[
            <>
              Ein Gerichtsverfahren kann sich unter Umständen <strong>über Jahre hinziehen</strong>, weshalb die psychische Belastung für Sie berücksichtigt
              werden muss.
            </>,
            <>
              Das Gericht kann Ihr persönliches <strong>Erscheinen vor Gericht</strong> anordnen. Dann sind Sie <strong>verpflichtet</strong> zu erscheinen und
              müssen sich hierfür entsprechend Urlaub nehmen.
            </>,
            <>
              <strong>
                Bitte beachten Sie: Auch bei guter Beweis- und Ausgangslage kann das Gerichtsverfahren verloren werden. Die Rechtsprechung unterliegt zudem
                regelmäßigen Veränderungen. Ein gerichtliches Verfahren ist daher stets mit einem Prozess- und Kostenrisiko verbunden.
              </strong>
            </>,
          ]}
        />
      </HighlightBox>
    </Grid>
  );
};
export default LawsuitConsequences;
